var map = {
	"./20091023_1.jpg": 64550,
	"./20091023_2.jpg": 22321,
	"./20091023_3.jpg": 43796,
	"./20091023_4.jpg": 45759,
	"./20091023_5.jpg": 25762,
	"./20091023_6.jpg": 57901,
	"./20091023_7.jpg": 30800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39664;